

exports.__esModule = true;

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _uiRouter = require('uiRouter');

require('./styles');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _auth = require('xo-models/src/auth');

var _index = require('components/xo-models/src/checkout/index');

var _index2 = require('components/xo-models/src/credit/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoChooseCreditOfferDirective', {
    tag: 'xo-choose-credit-offer',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        }
    },

    resolve: {
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve(),
                checkoutCart: _index.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                payee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
                creditOptions: _index2.$CreditInstallmentModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {
        redirectToReview: function redirectToReview() {
            $('body').removeClass('CYCOPage');
            this.creditDataModel.payInFull = true;
            if (!this.models.auth.logged_in) {
                _uiRouter.$state.go('checkout.login');
            } else {
                _uiRouter.$state.go('checkout.review');
            }
        },
        toggleSacOffer: function toggleSacOffer(isExtended) {
            this.sacExtended = isExtended ? false : true;
        },
        toggleInstallmentOffer: function toggleInstallmentOffer(isExtended) {
            this.installmentExtended = isExtended ? false : true;
        },


        getCreditFinancingCodes: function getCreditFinancingCodes(creditOffers) {
            var financingCodes = '';
            var installmentOffer = creditOffers.installment_options;
            var sacOffer = creditOffers.sac_options;

            if (installmentOffer && installmentOffer.length) {
                installmentOffer.forEach(function (installment) {
                    financingCodes += installment.financingCode;
                    financingCodes += ',';
                });
            }

            if (sacOffer) {
                financingCodes += sacOffer.financingCode;
            }

            return financingCodes;
        },

        onSelect: function onSelect(index) {
            var selectedOffer = index === 'SAC' ? this.creditOffers.sac_options : this.creditOffers.installment_options[index];
            var creditMemberType = this.isCreditInWallet ? 'existingMember' : 'newMember';
            var isPPCReuse = this.isCreditInWallet;
            var isBuyerSet = this.fundingInstruments;
            var isSignUpFlow = this.creditDataModel.isCreditSignup();
            var isChangeInstallment = this.creditDataModel.isChangeStatus();
            var country = this.models.checkoutAppData.merchant.merchant_country;

            var param = {
                'financing_code': selectedOffer.financingCode,
                'apr': selectedOffer.apr,
                'term': selectedOffer.term,
                'credit_type': selectedOffer.creditType,
                'paypal_subsidy': selectedOffer.paypalSubsidy
            };

            if (index !== 'SAC') {
                param.monthly_percentage_rate = selectedOffer.monthlyPercentageRate;
                param.total_cost = selectedOffer.totalPayment.value;
                param.total_interest = selectedOffer.totalInterest.value;
                param.monthly_payment = selectedOffer.monthlyPayment.value;
                param.currency = selectedOffer.monthlyPayment.currency;
            }

            return this.models.creditOptions.action('select', {
                data: param,
                success: function success(result) {
                    $('body').removeClass('CYCOPage');

                    _logger.$logger.info('checkout_fpti', {
                        'is_ppc_reuse': isPPCReuse ? '1' : '0',
                        'credit_type': selectedOffer.creditType,
                        'financing_code_selected': selectedOffer.financingCode
                    });

                    if (isBuyerSet && creditMemberType === 'newMember' || isSignUpFlow && isChangeInstallment) {
                        return (0, _squid.$pxp)('xo_hermes_cape_migration', {
                            'ctx.COUNTRY': country
                        }, 'xo_cape_migration_test').then(function (result) {
                            if (result && result.treatment_name === 'xo_cape_migration_test' || isSignUpFlow && isChangeInstallment) {
                                _uiRouter.$state.go('checkout.redirectToCape');
                            } else {
                                _uiRouter.$state.go('checkout.bmldisplay.bmlapply');
                            }
                        });
                    } else if (creditMemberType === 'existingMember') {
                        _uiRouter.$state.go('checkout.review');
                    } else {
                        _uiRouter.$state.go('checkout.login');
                    }
                }
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            this.offers = _index.$InstallmentOptionsModel.instance(this.props.token);
            this.checkoutSession = _index.$CheckoutSessionModel.instance(this.props.token);
            this.creditOffers = this.offers.installments && this.offers.installments[0];
            this.creditDataModel = _index2.$CreditDataModel.instance(this.props.token);
            this.installmentCount = this.creditOffers && this.creditOffers.installment_options && this.creditOffers.installment_options.length;

            $('.paypalHeaderWrapper').addClass('paypalCredit');
            $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
            $('body').addClass('CYCOPage');
        },
        populate: function populate() {
            var _this = this;

            this.fundingInstruments = this.checkoutSession.get('fundingOptions.instruments');
            if (this.models.auth.logged_in && this.fundingInstruments) {
                this.checkoutSession.retrieve();
            }
            this.isCreditInWallet = this.fundingInstruments && _squid.$util.some(this.fundingInstruments, function (fi) {
                return fi.type === 'CREDIT';
            });

            function getInstallmentContent(that) {
                var contentKey = 'chooseCreditOption.singleInstallmentDescription';
                var isZeroAprAvailable = false;

                if (that.installmentCount > 1) {
                    that.creditOffers.installment_options.forEach(function (installment) {
                        if (installment.apr === '0.00') {
                            isZeroAprAvailable = true;
                            contentKey = 'chooseCreditOption.installmentDescriptionAprZero';
                        }
                    });

                    if (!isZeroAprAvailable) {
                        contentKey = 'chooseCreditOption.installmentDescription2';
                    }
                }
                return contentKey;
            }

            this.offers.save({
                data: {
                    payee: this.models.payee,
                    checkoutCart: this.models.checkoutCart,
                    checkoutAppData: this.models.checkoutAppData,
                    isMemberCredit: true
                }, success: function success(result) {
                    _this.creditOffers = result.installments && result.installments[0];
                    _this.installmentCount = _this.creditOffers.installment_options && _this.creditOffers.installment_options.length;
                    _this.termsUrl = (0, _squid.$feature)('creditOfferSeeTermsUrl') + _this.creditOffers.terms_param;
                    _logger.$logger.info('checkout_fpti', {
                        'financing_code_offered': _this.actions.getCreditFinancingCodes(_this.creditOffers)
                    });

                    _this.installmentContentKey = getInstallmentContent(_this);
                }
            });
        }
    }

});


_squid.$Component;

_squid.$util;

_squid.$feature;

_squid.$pxp;

_logger.$logger;

_uiRouter.$state;

_auth.$AuthModel;

_index.$CheckoutSessionModel;

_index.$CheckoutCartModel;

_index.$InstallmentOptionsModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutAppDataModel;

_index2.$CreditInstallmentModel;

_index2.$CreditDataModel;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-credit-components/src/choose-credit-offer/directive.js
 ** module id = 485
 ** module chunks = 1
 **/